import { useTranslations } from "next-intl";
import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { useCurrentUser } from "@hooks/use-current-user";
import { getNextInvoiceSubscriptionAmount } from "@utils/call-api/next-invoice-call";
import SubscriptionRecap from "./SubscriptionRecap";
import ChangeSubscription from "./ChangeSubscription";
import SubscriptionPause from "./SubscriptionPause";
import SubscriptionCancelation from "./SubscriptionCancelation";

function ManageSubscription() {
  const t = useTranslations("accounts");

  const router = useRouter();
  const subscription = useCurrentUser()?.subscription;

  const [nextInvoiceSubscriptionAmount, setNextInvoiceSubscriptionAmount] = useState(null);
  const [currentCoupon, setCurrentCoupon] = useState(null);

  useEffect(() => {
    async function fetchNextInvoiceSubscriptionAmount() {
      if (!["active", "trialing", "past_due"].includes(subscription?.state)) return;

      try {
        const res = await getNextInvoiceSubscriptionAmount();
        const {
          next_invoice_subscription_amount: resNextInvoiceAmount,
          current_coupon: resCurrentCoupon,
        } = res;

        setNextInvoiceSubscriptionAmount(resNextInvoiceAmount);
        setCurrentCoupon(resCurrentCoupon);
      } catch {
        router.back();
      }
    }

    fetchNextInvoiceSubscriptionAmount();
  }, [subscription, router]);

  return (
    <div>
      <h2 className="pb-2 mb-4 d-none d-lg-block">{t("title_manage_subscription")}</h2>

      <SubscriptionRecap
        nextInvoiceSubscriptionAmount={nextInvoiceSubscriptionAmount}
        currentCoupon={currentCoupon}
      />

      <div className="d-flex flex-column gap-4">
        <ChangeSubscription />

        <div className="d-flex flex-column flex-lg-row gap-4">
          <SubscriptionPause />

          <SubscriptionCancelation currentCoupon={currentCoupon} />
        </div>
      </div>
    </div>
  );
}

export default ManageSubscription;
